export const SET_FILTER_DATA = 'Set_Filter_Data';